
/**
 * Source: FGFactoryBlueprintTypes.h
 */
export enum BlueprintConfigVersion {
    InitialVersion,
    AddedMD5Hash,
    RemovedMD5Hash,
    AddedIconLibraryPath,
    AddedLastEditedBy,
    AddedFilteredProfanityName,
    RemovedFilteredProfanityName,
    VersionPlusOne,
    LatestVersion = VersionPlusOne - 1
}